import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlogComponent } from 'src/app/pages/blog/blog/blog.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BlogArticleDetailComponent } from 'src/app/pages/blog/blog-article-detail/blog-article-detail.component';
import { BlogArticlePreviewExternalComponent } from 'src/app/pages/blog/blog-article-preview-external/blog-article-preview-external.component';

const routes: Routes = [
  {
    path: '',
    component: BlogComponent,
    canActivate: [AuthenticationService],
  },
  {
    path: ':articleId',
    component: BlogArticleDetailComponent,
    canActivate: [AuthenticationService],
  },
  {
    path: 'preview/:articleSecret',
    component: BlogArticlePreviewExternalComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogRoutingModule { }
